import { SAVE_KEYS } from "../Constants/SaveKeys";
import { PlayerDataSingleton } from "./PlayerDataSingleton";
import { ENGINE_DEBUG_MODE } from "../../engine/Constants/Constants";

export class SavedDataUpgradeFunctions {

    // Inner array is format of [...fromVersions, toVersion]
    public static readonly versions: Array<Array<string>> = [
        ["0.0.*", "0.1.*", "0.2.*", "0.3.0", "0.3.1",
            "0.3.2"],
        ["0.0.*", "0.1.*", "0.2.*", "0.3.0", "0.3.1", "0.3.2",
            "0.3.3"],
        ["0.0.*", "0.1.*", "0.2.*", "0.3.0", "0.3.1", "0.3.2", "0.3.3",
            "0.3.4"],
        ["0.0.*", "0.1.*", "0.2.*", "0.3.0", "0.3.1", "0.3.2", "0.3.3", "0.3.4",
            "0.3.5"],
        ["0.0.*", "0.1.*", "0.2.*", "0.3.*",
            "0.4.0"],
        ["0.0.*", "0.1.*", "0.2.*", "0.3.*", "0.4.0",
            "0.4.1"],
    ];

    public static readonly versionsToFunctions: Record<string, Function> = {
        "0.3.2": SavedDataUpgradeFunctions.up_032,
        "0.3.3": SavedDataUpgradeFunctions.up_033,
        "0.3.4": SavedDataUpgradeFunctions.up_034,
        "0.3.5": SavedDataUpgradeFunctions.up_035,
        "0.4.0": SavedDataUpgradeFunctions.up_040,
        "0.4.1": SavedDataUpgradeFunctions.up_041,
    };

    constructor() {
        throw new Error("Static class not meant for instantiation");
    }

    private static up_032(_pdataSingleton: typeof PlayerDataSingleton): void {
        _pdataSingleton.resetAllData();
    }

    private static up_033(_pdataSingleton: typeof PlayerDataSingleton): void {
        // do nothing
    }

    private static up_034(_pdataSingleton: typeof PlayerDataSingleton): void {
        // do nothing
    }

    private static up_035(_pdataSingleton: typeof PlayerDataSingleton): void {
        _pdataSingleton.resetAllData();
    }

    private static up_040(_pdataSingleton: typeof PlayerDataSingleton): void {
        _pdataSingleton.resetAllData();
    }

    private static up_041(_pdataSingleton: typeof PlayerDataSingleton): void {
        // do nothing
    }

    public static upgradeData(
        _playerDataSingleton: (typeof PlayerDataSingleton),
        _toVersion: string,
    ): void {
        const fromStr = _playerDataSingleton.getGameVersionStr();
        if(fromStr === _toVersion) {
            if(ENGINE_DEBUG_MODE) {
                console.log("[SavedDataUpgradeFunctions] Skipping upgrade from %s", fromStr);
            }
            return;
        }

        const toSplit = _toVersion.split(".");
        const toMajor = toSplit[0];
        const toMinor = toSplit[1];
        const toPatch = toSplit[2];
        const fromSplit = (fromStr).split(".");
        const fromMajor = fromSplit[0];
        const fromMinor = fromSplit[1];
        const fromPatch = fromSplit[2];

        if(ENGINE_DEBUG_MODE) {
            console.log("[SavedDataUpgradeFunctions] Upgrading from %s to %s", fromStr, _toVersion);
        }

        const versionData = SavedDataUpgradeFunctions.versions.find((e) => {
            return e[e.length - 1] === _toVersion;
        });
        const versionFunc = SavedDataUpgradeFunctions.versionsToFunctions[_toVersion];

        if(!versionData || !versionFunc) {
            console.error("Missing version data/function!");
            return;
        }

        if(
            !versionData.find((e) => {
                return fromStr.match(e);
            })
        ) {
            console.warn(
                "There isn't a valid upgrade path from %s to %s, skipping...",
                fromStr,
                _toVersion
            );
            return;
        }

        // run versionFunc
        versionFunc(_playerDataSingleton);
        _playerDataSingleton.setGameVersionStr(__VERSION);

        if(ENGINE_DEBUG_MODE) {
            console.log("[SavedDataUpgradeFunctions] Upgraded from %s to %s", fromStr, __VERSION);
        }

        return;
    }


}